module.exports = __webpack_public_path__ + "img/henkel-belenes.a0169abd.jpg";